import { getKeyByValue } from "./Helpers/FormatHelpers";

function convertUnits(value, fromUnit, toUnit) {
  const unitConversionRates = {
    mm: 1,
    cm: 10,
    m: 1000,
    in: 25.4,
    ft: 304.8,
    yd: 914.4,
    km: 1000000,
  };

  if (!unitConversionRates[fromUnit] || !unitConversionRates[toUnit]) {
    throw new Error("Invalid unit specified for conversion");
  }

  const valueInBaseUnit = value * unitConversionRates[fromUnit];
  return valueInBaseUnit / unitConversionRates[toUnit];
}

/**
 * Updates the custom resize field values for a given selection by converting
 * the values from one unit to another and committing the changes to the store.
 *
 * @param {string} selectionId - The unique identifier for the selection to update.
 * @param {string} oldValueId - The identifier for the old unit of measurement.
 * @param {string} newValueId - The identifier for the new unit of measurement.
 *
 * @throws {Error} Logs an error if the update process fails.
 */
export function updateCustomResizeFieldValues(
  selectionId,
  oldValueId,
  newValueId
) {
  try {
    const userData = Object.assign(
      {},
      JSON.parse(JSON.stringify($nuxt.$store.state.advancedSetting.userData))
    );
    const fieldNames = userData["fieldNames"];
    const selection = userData.allSelection[selectionId];

    const oldUnit = fieldNames[oldValueId];
    const newUnit = fieldNames[newValueId];

    const affectedFieldIds = [
      getKeyByValue(fieldNames, "pdf_custom_resize_width"),
      getKeyByValue(fieldNames, "pdf_custom_resize_height"),
    ];

    affectedFieldIds.forEach((affectedFieldId) => {
      if (affectedFieldId) {
        const oldValue = selection[affectedFieldId];
        let newValue = convertUnits(oldValue, oldUnit, newUnit);

        if (newUnit === "in") {
          newValue = Math.round(newValue * 100) / 100; // Round to 2 decimal places
        } else {
          newValue = Math.round(newValue); // Round to the nearest integer
        }

        $nuxt.$store.commit("advancedSetting/setSelection", {
          uid: selectionId,
          key: affectedFieldId,
          value: newValue,
          fromUpdate: true,
        });
      }
    });
  } catch (error) {
    console.error("Error updating custom resize field values:", error);
  }
}

export function getSelectedResizeUnit(userDataState) {
  const userData = Object.assign(
    {},
    JSON.parse(JSON.stringify(userDataState))
  );
  const fieldNames = userData["fieldNames"];
  const resizeUnitId = getKeyByValue(fieldNames, "pdf_custom_resize_unit");

  const selection = userData.allSelection["root"][resizeUnitId];
  return fieldNames[selection] || "mm";
}

export function getMinMaxResizeValues(unit) {
  if (!unit) {
    unit = getSelectedResizeUnit();
  }

  return unit === "in" ? { min: 1, max: 11650 } : { min: 1, max: 295931 };
}
